export const PARTNER_ROLE_VALUES = [
  'customer',
  'travelAgency',
  'eventOrganizer',
  'facilityProvider',
  'serviceProvider',
  'researchPartner',
] as const;

export type ProfileRoleTypeValue = (typeof PARTNER_ROLE_VALUES)[number];

const LEGACY_ROLE_TYPE_MAP: Record<string, ProfileRoleTypeValue> = {
  service_provider: 'serviceProvider',
  event_organizer: 'eventOrganizer',
};

/** Default when partnerRole is unknown — matches unclassified front-end users. */
export const DEFAULT_PROFILE_ROLE_TYPE: ProfileRoleTypeValue = 'customer';

export function isProfileRoleTypeValue(value: string): value is ProfileRoleTypeValue {
  return (PARTNER_ROLE_VALUES as readonly string[]).includes(value);
}

/** Normalize Firestore roleType values (supports legacy snake_case). */
export function normalizeProfileRoleType(raw: unknown): ProfileRoleTypeValue {
  if (typeof raw !== 'string') {
    return DEFAULT_PROFILE_ROLE_TYPE;
  }
  const legacy = LEGACY_ROLE_TYPE_MAP[raw];
  if (legacy) {
    return legacy;
  }
  if (isProfileRoleTypeValue(raw)) {
    return raw;
  }
  return DEFAULT_PROFILE_ROLE_TYPE;
}
